import type { AIModelChoices } from 'api';

import { isOtherAiModel } from '../../../evidence';
import { getAspectRatio } from '../../utils/captureImage/captureImage';
import { useAutoCapture } from '../useAutoCapture/useAutoCapture';
import { useCameraStream } from '../useCameraStream/useCameraStream';
import { useDeviceShake } from '../useDeviceShake/useDeviceShake';
import { useTilt } from '../useTilt/useTilt';
import { useWakeLock } from '../useWakeLock/useWakeLock';

export const useCamera = ({ aiModel }: { aiModel: AIModelChoices }) => {
  const skipGuidance = isOtherAiModel(aiModel);
  const { releaseWakeLock } = useWakeLock();
  const { isCameraLevel, isPortrait, tiltDirection } = useTilt({ aiModel });
  const { isStill } = useDeviceShake();
  const aspectRatio = getAspectRatio({ aiModel, isPortrait });
  const { stream, isLoading, releaseStream, flashEnabled, toggleFlash } = useCameraStream({ aspectRatio, isPortrait });

  const isDeviceReady = skipGuidance || Boolean(isStill && isCameraLevel);
  const { autoCapturing, countdown, toggleAutoCapture, shouldCapture, markCaptureTriggered } = useAutoCapture({
    isDeviceReady,
  });

  return {
    autoCapturing,
    countdown,
    flashEnabled,
    isDeviceReady,
    isLoading,
    isPortrait,
    markCaptureTriggered,
    releaseStream,
    releaseWakeLock,
    shouldCapture,
    skipGuidance,
    stream,
    tiltDirection,
    toggleAutoCapture,
    toggleFlash,
  };
};
